import React, { Component } from 'react';

import { Transition } from "react-transition-group";
import Badge from 'react-bootstrap/Badge';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';

import './UserNavbar.css';


const topStyles = {
  entering: {
    transition: 'top 1s ease',
    top: '0px',
  },
  entered: {
    top: '0px',
  },
  exiting: {
    transition: 'top 1s ease',
    top: '-64px',
  },
  exited: {
    top: '-64px',
  }
}


class UserNavbar extends Component {
  reportIssue() {
    if (!this.props.onReportIssue) {
      return
    }
    this.props.onReportIssue()
  }

  abort() {
    if (!this.props.onAbort) {
      return
    }
    this.props.onAbort()
  }

  signOut() {
    if (!this.props.onSignOut) {
      return
    }
    this.props.onSignOut()
  }

  renderProgress() {
    if (!this.props.progress) {
      return null
    }
    const page = this.props.progress.page
    const sentence = this.props.progress.sentence
    if (page && page.all > 1) {
      return `${page.current + 1} / ${page.all} ページ`
    }
    return `${sentence.current + 1} / ${sentence.all} 文`
  }

  toPreviousPage() {
    if (!this.props.onPreviousPage) {
      return
    }
    this.props.onPreviousPage()
  }

  toNextPage() {
    if (!this.props.onNextPage) {
      return
    }
    this.props.onNextPage()
  }

  toFirstPage() {
    if (!this.props.onFirstPage) {
      return
    }
    this.props.onFirstPage()
  }

  toLastPage() {
    if (!this.props.onLastPage) {
      return
    }
    this.props.onLastPage()
  }

  resetContext() {
    if (!this.props.onResetContext) {
      return
    }
    this.props.onResetContext()
  }

  renderNavbar(state) {
    return (<Navbar
      className='UserNavbar'
      collapseOnSelect expand='lg' bg={`navbar-${this.props.theme || 'default'}`}
      sticky={state === 'entered' && 'top'}
      variant='dark'
      style={topStyles[state]}
    >
      <Navbar.Brand href="#">
        <img
          alt=""
          src="/logo192.png"
          width="30"
          height="30"
          className="d-inline-block align-top"
        />{' '}
        Cloze Test
        {this.props.user !== null &&
          <span id='mitou_ml_account'>{this.props.user.email}</span>}
      </Navbar.Brand>
      <Navbar.Toggle aria-controls='responsive-navbar-top' />
      <Navbar.Collapse id='responsive-navbar-top' className='justify-content-end'>
        {this.props.progress && <Nav className="mr-auto">
          {this.props.abortable ? <NavDropdown title={this.renderProgress()}>
            <NavDropdown.Item onClick={(e) => this.abort(e)}>
              中断
            </NavDropdown.Item>
            {this.props.hasPreviousPage &&
              <NavDropdown.Item onClick={(e) => this.toPreviousPage()}>
                前のページ
              </NavDropdown.Item>}
            {this.props.hasNextPage &&
              <NavDropdown.Item onClick={(e) => this.toNextPage()}>
                次のページ
              </NavDropdown.Item>}
            {this.props.hasFirstPage &&
              <NavDropdown.Item onClick={(e) => this.toFirstPage()}>
                最初のページ
              </NavDropdown.Item>}
            {this.props.hasLastPage &&
              <NavDropdown.Item onClick={(e) => this.toLastPage()}>
                最後のページ
              </NavDropdown.Item>}
            {this.props.hasResetContext &&
              <NavDropdown.Item onClick={(e) => this.resetContext()}>
                回答経過を全てリセット
              </NavDropdown.Item>}
          </NavDropdown> : <Nav.Link>{this.renderProgress()}</Nav.Link>}
        </Nav>}
        {!this.props.progress && !this.props.noContext && <Nav className="mr-auto">
          <Nav.Link href='/recent/'>
            最近参照した問題
            {this.props.incompleteTasks && this.props.incompleteTasks.length > 0 &&
              <Badge variant='danger'>{this.props.incompleteTasks.length}</Badge>}
          </Nav.Link>
        </Nav>}
        {!this.props.noContext && <Nav>
          <NavDropdown title='使い方'>
            <NavDropdown.Item href='https://youtu.be/DOT9vOMHols' target='_blank'>
              使い方動画(YouTube)
            </NavDropdown.Item>
          </NavDropdown>
          {this.props.user === null ?
            <Navbar.Text>
              ログインしていません
            </Navbar.Text> :
            <NavDropdown
              title={`ログイン中: ${this.props.user.email}`}>
              {this.props.progress && <NavDropdown.Item onClick={e => this.reportIssue()}>
                問題を報告
              </NavDropdown.Item>}
              <NavDropdown.Item href='/dashboard/'>
                ダッシュボード
              </NavDropdown.Item>
              <NavDropdown.Item href='/notice/' target='_blank'>
                利用上の注意(対応ブラウザ)
              </NavDropdown.Item>
              <NavDropdown.Item href='/inquiry/' target='_blank'>
                お問い合わせ
              </NavDropdown.Item>
              <NavDropdown.Item onClick={e => this.signOut()}>
                ログアウト
              </NavDropdown.Item>
            </NavDropdown>}
        </Nav>}
      </Navbar.Collapse>
    </Navbar>)
  }

  render() {
    return (<Transition in={this.props.open === undefined || this.props.open} timeout={1000} >
      {(state) => this.renderNavbar(state)}
    </Transition>)
  }
}

export default UserNavbar;
